<template>
  <div>
    <AppHeader />
    <router-view />
    <AppFooter />
  </div>
</template>

<script>
import AppFooter from '@/components/common/AppFooter.vue';
import AppHeader from '@/components/common/AppHeader.vue';

export default {
  name: "DefaultLayout",
  components: {
    AppFooter,
    AppHeader,
  },
};
</script>

<style scoped>
/* Add any necessary styling here */
</style>